import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
// connect gives as access to state from redux store
import _ from "lodash";
import PropTypes from "prop-types";
import { logout, removeGreetings } from "../actions/authActions";
import { changePage } from "../actions/changePageAction";
import { clearErrors } from "../actions/errorActions";
import { getProjects } from "../actions/projectActions";
import { changeLanguage, updateUser } from "../actions/userActions";
import {
  deleteProfilePictures,
  pictureDownload,
} from "./../actions/pictureAction";
import i18n from "./helper/i18n";
import { Translation } from "./helper/transComp";
// import FilterLink from "./container/FilterLink";
import {
  Button,
  Container,
  Modal,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import NavigationLink from "./container/NavigationLink";
import ProfileLink from "./container/ProfileLink";
// import { WebSocketContext } from "./../WebSocket";
import { WebsocketContext } from "./../WebsocketContext";
import { FolderBlack } from "./../components/helper/icon/icon";
import OutsideAlerter from "./helper/functions/OutsideAlerter";
// import { openWSConnection } from "../actions/websocketAction";
// import { getWSService } from "../WSService";
// import { wsRoomInit } from "../WSRoom";
import useSessionTracker from "../utils/useSessionTracker";
import { endCurrentSessionManually } from "../utils/sessionUtils";
import { MdSpeed } from "react-icons/md";

class HeaderLoggedIn extends Component {
  static contextType = WebsocketContext;
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      width: 0,
      height: 0,
      displMenu: false,
      languages: ["en", "de", "fr"],
      currLan: "en",
      register: false,
      login: false,
      images: [],
      isAuthenticated: false,
      displayModal: false,
      displayHelp: false,
      projObj: {},
      homeObj: {},
      addProjObj: {},
      addItemObj: {},
      addTaskObj: {},
      addChartObj: {},
      currHelp: -1,
      navbarExpanded: false,
      videoSrc: "create_project_ws_EN.mp4",
      displayChat: false,
      profilePopupOpen: false,
      showNewsLetter: 4,
      // displayGreetings: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  intervalID1 = 1;
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if (this.props.user) {
      if (this.props.user.user) {
        if (this.props.user.user.language) {
          if (
            this.props.user.user.language !== "" &&
            this.props.user.user.language !== undefined
          ) {
            this.props.updateUser({
              modUser: true,
              language: this.props.user.language,
            });
            let videoSrc = "create_project_ws_EN.mp4";
            if (this.props.user.user.language === "de") {
              videoSrc = "create_project_ws_DE.mp4";
            } else if (this.props.user.user.language === "fr") {
              videoSrc = "create_project_ws_FR.mp4";
            }
            this.setState({ videoSrc });
          } else {
            this.props.updateUser({
              modUser: true,
            });
          }
        } else {
          this.props.updateUser({
            modUser: true,
          });
        }
        this.props.updateUser({
          modUser: true,
          updateAddressBook: true,
        });
      } else {
        this.props.updateUser({
          modUser: true,
        });
      }
    } else {
      this.props.updateUser({
        modUser: true,
      });
    }
    if (this.context) {
      if (this.context.connect) {
        this.context.connect();
      }
    }
    // if (this.context.setConnected) {

    //   this.context.setConnected(true);
    // }
    //*****COMMENTED LINE 130 AND 131
    // this.checkLogIn();
    // this.intervalID1 = setInterval((e) => this.checkLogIn(), 300000); //every 5 min
    // console.log("lfdjgljerthglke", this.props.auth.tokenType);
    // if (this.props.auth.tokenType === "free") {
    //   this.props.logout();
    // }
    if (this.props.auth.greetings) {
      setTimeout(() => {
        this.props.removeGreetings();
      }, 5 * 60 * 1000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    clearInterval(this.intervalID1);

    // clearInterval(this.inactivityInterval);
    if (this.inactivityInterval) {
      clearInterval(this.inactivityInterval);
    }
  }

  componentDidUpdate() {
    const { isAuthenticated } = this.props;
    if (this.state.isAuthenticated !== isAuthenticated) {
      this.setState({ isAuthenticated });
      if (this.props.picture.images)
        if (!this.props.picture.images.length) {
          if (!this.props.picture.images.user) this.props.pictureDownload();
        }
    }
    if (this.state.login || this.state.register) {
      if (isAuthenticated) {
        this.setState({
          login: false,
          register: false,
          isOpen: false,
        });
        this.props.changePage("home");
        this.props.clearErrors();
      }
    }
    if (this.props.picture !== undefined) {
      if (this.props.picture.images !== undefined) {
        if (this.props.picture.images !== this.state.images) {
          this.setState({ images: this.props.picture.images });
        }
      }
    }
    if (this.props.user)
      if (this.props.user.user)
        if (this.props.user.user.language)
          if (this.props.user.user.language !== this.state.currLan) {
            i18n.changeLanguage(this.props.user.user.language);
            this.setState({ currLan: this.props.user.user.language });
          }
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    changePage: PropTypes.func.isRequired,
    page: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    getProjects: PropTypes.func.isRequired,
    picture: PropTypes.object,
    logout: PropTypes.func.isRequired,
    deleteProfilePictures: PropTypes.func.isRequired,
    pictureDownload: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
    changeLanguage: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  displayPage = (e, pageTitle) => {
    e.preventDefault();
    this.props.changePage(pageTitle);
  };

  getLangTxt = () => {
    switch (this.props.user.language) {
      case "de":
        return "DE";
      case "fr":
        return "FR";
      default:
        return "EN";
    }
  };

  render() {
    let userImg = (
      <img
        className="profilePic"
        src={`/img/user.png`}
        alt={"profil"}
        style={{
          width: "40px",
          height: "40px",
        }}
      />
    );

    return (
      <Fragment>
        <Modal
          show={this.state.displayModal}
          onHide={() => this.setState({ displayModal: false })}
          dialogClassName="modal-small"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title"></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>
              <Translation str={"HeaderSession"} />
            </h5>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.props.auth.greetings === true}
          onHide={() => this.props.removeGreetings()}
          // dialogClassName="modal-large"
          size={"lg"}
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <Translation str={"HeaderNews"} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Translation str={"HeaderGreetings1"} />{" "}
              {this.props.user
                ? this.props.user.user
                  ? this.props.user.user.firstName
                    ? this.props.user.user.firstName
                    : null
                  : null
                : null}
              ,
            </p>

            <p style={{ marginTop: "1rem" }}>
              <Translation str={"HeaderGreetings2"} />
            </p>
            <p style={{ marginTop: "1.5rem" }}>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  margin: "2rem auto",
                  textAlign: "center",
                  color: "#008910",
                }}
              >
                <Translation str={"HeaderNewFeatures"} />
              </div>
              {/* <div style={{ maxWidth: "1280px", marginTop: "1rem" }}>
                <video controls width="100%" loop className="blog-video">
                  <source
                    // muted
                    src="https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+5.mp4"
                    // src="https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+4+-+actualite+du+mois+d+octobre_v1.mp4"
                    type="video/mp4"
                  />
                  {/* <Translation str={"KabanVideo"} /> 
                </video>
              </div> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  minHeight: "400px", // optional, for vertical centering
                }}
              >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/ZxCx1i0XUqo?si=7CcBP4I6xRg45tUh"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </p>
            <Button
              variant="submit100"
              style={{ width: "100%", borderRadius: "10px" }}
              onClick={() => {
                this.setState({
                  displayHelp: true,
                  currVideo: 2,
                  showNewsLetter: true,
                });
                this.props.removeGreetings();
              }}
            >
              Voir l'intégralité de la newsletter.
            </Button>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.displayHelp}
          onHide={() => this.setState({ displayHelp: false })}
          // dialogClassName="modal-large"
          size={"lg"}
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <Translation str={"HeaderCanHelp"} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Translation str={"HeaderQuestions"} />
            <a href="mailto:support@luckiwi.com" style={{ color: "black" }}>
              support@luckiwi.com.
            </a>
            <div style={{ display: "flex" }}>
              <div className="headerHelpMenuVideoBoxLeft">
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 4
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 4 });
                  }}
                >
                  <Translation str={"ResourcePlanningJun"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 3
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 3 });
                  }}
                >
                  <Translation str={"ResourcePlanningMay"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 2
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 2 });
                  }}
                >
                  <Translation str={"ResourcePlanningMar"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 1
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 1 });
                  }}
                >
                  <Translation str={"ResourcePlanningFeb"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 0
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 0 });
                  }}
                >
                  <Translation str={"ResourcePlanningOct"} /> 2024
                </div>
              </div>
              <div
                className="headerHelpMenuVideoBoxRight"
                style={{ maxHeight: "350px", overflow: "scroll" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: "#008910",
                    margin: "20px 0",
                  }}
                >
                  {this.state.showNewsLetter == 0 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+4+-+actualite+du+mois+d+octobre_v1.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : this.state.showNewsLetter == 1 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter_2025_01.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : this.state.showNewsLetter == 2 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter2_final.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : this.state.showNewsLetter == 3 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter3_final.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+5.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <div>
          <Navbar
            bg="light"
            expand="md"
            fixed="top"
            key={"md"}
            className="mb-3"
            expanded={this.state.navbarExpanded}
            onToggle={() => {
              this.setState({
                navbarExpanded: !this.state.navbarExpanded,
              });
            }}
          >
            <Container>
              <ProfileLink
                navLinkClicked={(e) => {
                  this.setState({ isOpen: false });
                }}
                style={{ width: "fit-content" }}
                filter={this.props.isAuthenticated ? "/projects" : "./"}
              >
                {this.props.company?.companies?.[0]?.logo?.picture !== "" &&
                this.props.company?.companies?.[0]?.logo?.picture !==
                  undefined ? (
                  <div
                    class="logo-wrapper"
                    style={{ marginRight: "20px", minWidth: "110px" }}
                  >
                    <img
                      src={this.props.company.companies[0].logo.picture}
                      alt="Ton image"
                      style={{
                        height: "40px",
                      }}
                    />
                    <div class="credit">
                      <Translation str={"HeaderPowered"} />
                    </div>
                  </div>
                ) : (
                  <img
                    src={`/img/logo.webp`}
                    alt={"logo"}
                    style={{
                      height: "60px",
                    }}
                  />
                )}
              </ProfileLink>
              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                style={{ background: "#a1c5a3", marginRight: "10px" }}
              />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                  <NavigationLink
                    navLinkClicked={() => {
                      this.setState({ isOpen: false, navbarExpanded: false });
                    }}
                    filter={"./projects"}
                    style={{ color: "#424141" }}
                  >
                    <div id="basic-navbar-project">
                      <FolderBlack color="#424141" height="16px" />
                      <span>
                        <Translation str={"HeaderProject"} />
                      </span>
                    </div>
                  </NavigationLink>
                  <NavigationLink
                    navLinkClicked={() => {
                      this.setState({ isOpen: false, navbarExpanded: false });
                    }}
                    filter={"./home"}
                    style={{ color: "#424141" }}
                  >
                    <div id="basic-navbar-home">
                      <img
                        src="/img/personnalspace.png"
                        style={{ height: "15px" }}
                      />
                      <span>
                        <Translation str={"HeaderPersonalSpace"} />
                      </span>
                    </div>
                  </NavigationLink>
                  {this.props.user.user?.shareList?.resources?.length > 0 ? (
                    <NavigationLink
                      navLinkClicked={() => {
                        this.setState({ isOpen: false, navbarExpanded: false });
                      }}
                      filter={"./manager"}
                      style={{ color: "#424141" }}
                    >
                      <div id="basic-navbar-home">
                        <img
                          src="/img/briefcase.png"
                          style={{ height: "15px" }}
                        />
                        <span>
                          <Translation str={"HeaderManagerView"} />
                        </span>
                      </div>
                    </NavigationLink>
                  ) : null}
                  {this.props.user ? (
                    this.props.user.user ? (
                      this.props.user.user.position ? (
                        this.props.user.user.position === "admin" ||
                        this.props.user.user.position === "admin2" ||
                        this.props.user.user.position === "owner" ? (
                          <>
                            {/* Dashboard Analytics moderne */}
                            <NavigationLink
                              navLinkClicked={() => {
                                this.setState({
                                  isOpen: false,
                                  navbarExpanded: false,
                                });
                              }}
                              filter={"administration"}
                              style={{ color: "#424141" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                {/* Utiliser une icône existante au lieu de analytics.png */}
                                <MdSpeed size={20} color="#424141" />
                                <span>Dashboard</span>
                              </div>
                            </NavigationLink>
                            {/* Backend Analytics (nouveau) */}
                            <NavigationLink
                              navLinkClicked={() => {
                                this.setState({
                                  isOpen: false,
                                  navbarExpanded: false,
                                });
                              }}
                              filter={"administration-backend"}
                              style={{ color: "#424141" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <MdSpeed size={20} color="#424141" />
                                <span>Backend Analytics</span>
                              </div>
                            </NavigationLink>

                            {/* Administration ancienne */}
                            <NavigationLink
                              navLinkClicked={() => {
                                this.setState({
                                  isOpen: false,
                                  navbarExpanded: false,
                                });
                              }}
                              filter={"administration-old"}
                              style={{ color: "#424141" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <MdSpeed size={20} color="#424141" />
                                <span>Admin 1.0</span>
                              </div>
                            </NavigationLink>
                          </>
                        ) : null
                      ) : null
                    ) : null
                  ) : null}
                  {this.props.user?.user?.crm === 1 ||
                  this.props.user?.user?.crm === 2 ? (
                    <NavigationLink
                      navLinkClicked={() => {
                        this.setState({
                          isOpen: false,
                          navbarExpanded: false,
                        });
                      }}
                      filter={"email"}
                      style={{ color: "#424141" }}
                    >
                      {/* <Translation str={"HeaderAdministration"} /> */}
                      Email
                    </NavigationLink>
                  ) : null}
                </Nav>
                <Nav className="me-0 ms-auto">
                  <ProfileLink
                    centered="1"
                    navLinkClicked={(e) => {
                      this.setState({ isOpen: false, navbarExpanded: false });
                    }}
                    filter={this.props.isAuthenticated ? "/notification" : "./"}
                  >
                    <OverlayTrigger
                      placement={"bottom"}
                      className="notification"
                      delay={{ show: 250, hide: 400 }}
                      overlay={
                        <Tooltip id="button-tooltip" className="notification">
                          <Translation str={"HeaderNotification"} />
                        </Tooltip>
                      }
                    >
                      <div
                        style={{
                          position: "relative",
                          width: "30px",
                          display: "flex",
                        }}
                      >
                        <img src={`/img/bell.svg`} alt={"notifications"} />
                        <div
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-15px",
                            fontSize: "12px",
                            width: "24px",
                            height: "24px",
                            color: "#f00",
                          }}
                        >
                          {this.props.user
                            ? this.props.user.user
                              ? this.props.user.user.notification
                                ? this.props.user.user.notification.length > 0
                                  ? this.props.user.user.notification.length
                                  : null
                                : null
                              : null
                            : null}
                        </div>
                        <p className="headerNotifP">
                          <Translation str={"HeaderNotification"} />
                        </p>
                      </div>
                    </OverlayTrigger>
                  </ProfileLink>
                  <OverlayTrigger
                    placement={"bottom"}
                    className="notification"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id="button-tooltip" className="notification">
                        <Translation str={"HeaderSendNotif"} />
                      </Tooltip>
                    }
                  >
                    <div style={{ padding: "18px 4px 18px" }}>
                      <label className="switch">
                        <input
                          type={"checkbox"}
                          id={`sendNotifications`}
                          name={""}
                          style={{ margin: "0 0.6rem" }}
                          checked={
                            this.props.user?.user?.notificationSend || false
                          }
                          onChange={(e) => {
                            this.props.updateUser({
                              modUser: true,
                              notificationSend:
                                this.props.user?.user?.notificationSend === true
                                  ? false
                                  : true,
                            });
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </OverlayTrigger>
                  {this.props.user?.user?.billing?.displayBilling ? (
                    <ProfileLink
                      centered="1"
                      navLinkClicked={(e) => {
                        this.setState({
                          isOpen: false,
                          navbarExpanded: false,
                        });
                      }}
                      filter={this.props.isAuthenticated ? "/pricing" : ""}
                    >
                      <OverlayTrigger
                        placement={"bottom"}
                        className="price"
                        style={{ margin: "0 auto" }}
                        delay={{ show: 250, hide: 400 }}
                        overlay={
                          <Tooltip id="button-tooltip">
                            <Translation str={"HeaderSub"} />
                          </Tooltip>
                        }
                      >
                        <div
                          style={{
                            position: "relative",
                            width: "30px",
                            display: "flex",
                          }}
                        >
                          <img
                            src={`/img/subscription.webp`}
                            alt={"abonnemnent"}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-15px",
                              fontSize: "12px",
                              width: "24px",
                              height: "24px",
                              color: "#f00",
                            }}
                          ></div>
                          <p className="headerNotifP">
                            <Translation str={"HeaderSub"} />
                          </p>
                        </div>
                      </OverlayTrigger>
                    </ProfileLink>
                  ) : null}
                  <div className="headerHelp" style={{ display: "flex" }}>
                    <OverlayTrigger
                      placement={"bottom"}
                      delay={{ show: 250, hide: 400 }}
                      overlay={
                        <Tooltip id="button-tooltip">
                          <Translation str={"HeaderHelp"} />
                        </Tooltip>
                      }
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                        }}
                        onClick={() => {
                          let projObj = document.getElementById(
                            "basic-navbar-project"
                          );
                          let homeObj =
                            document.getElementById("basic-navbar-home");
                          let addProjObj =
                            document.getElementById("addProject");
                          let addTaskObj = document.getElementById("addTask");
                          let addChartObj = document.getElementById("addChart");
                          let addItemObj = document.getElementById("addItem");
                          let url = window.location.href;
                          let currPage = url.split("/");
                          this.setState({
                            displayHelp: !this.state.displayHelp,
                            projObj,
                            homeObj,
                            addProjObj,
                            addTaskObj,
                            addItemObj,
                            addChartObj,
                          });
                        }}
                        id="help"
                      >
                        <img src={`/img/help.svg`} alt={"help"} />
                        <p className="headerNotifP">
                          <Translation str={"HeaderHelp"} />
                        </p>
                      </div>
                    </OverlayTrigger>
                  </div>
                  <NavDropdown
                    title={
                      this.props.user.language !== this.state.currLan ? (
                        <span
                          style={{
                            color: "#424141",
                            fontWeight: "bold",
                            display: "flex",
                            lineHeight: "20px",
                          }}
                        >
                          <img
                            src={"/img/world.svg"}
                            alt="language"
                            style={{
                              width: "20px",
                              marginTop: "5px",
                              marginRight: "2.5px",
                            }}
                          />{" "}
                          {this.getLangTxt(this.props.user.language)}
                        </span>
                      ) : (
                        <span
                          style={{
                            color: "#424141",

                            lineHeight: "30px",
                          }}
                        >
                          <img
                            src={"/img/world.svg"}
                            alt="language"
                            style={{ width: "20px" }}
                          />{" "}
                          {this.getLangTxt(this.props.user.language)}
                        </span>
                      )
                    }
                    id="basic-nav-dropdown-topnav"
                  >
                    {_.map(this.state.languages, (tval, tind) => {
                      return (
                        <NavDropdown.Item
                          className={"hoverMenu buttonContainerStart"}
                          style={{
                            backgroundColor:
                              this.state.currLan === tval ? "#d6d6d6" : "",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              currLan: tval,
                              isOpen: false,
                              navbarExpanded: false,
                            });
                            i18n.changeLanguage(tval);
                            this.props.updateUser({
                              modUser: true,
                              language: tval,
                            });
                          }}
                          key={tind}
                        >
                          <span
                            style={{ marginLeft: "0.25rem", cursor: "pointer" }}
                          >
                            {tval === "en" ? (
                              <>
                                <img
                                  src={`/img/english.webp`}
                                  style={{
                                    height: "30px",
                                    margin: "0 10px 0 5px",
                                  }}
                                />
                                <span>English </span>
                              </>
                            ) : tval === "de" ? (
                              <>
                                <img
                                  src={`/img/german.webp`}
                                  style={{
                                    height: "30px",
                                    margin: "0 10px 0 5px",
                                  }}
                                />
                                <span>Deutsch</span>
                              </>
                            ) : (
                              <>
                                <img
                                  src={`/img/french.webp`}
                                  style={{
                                    height: "30px",
                                    margin: "0 10px 0 5px",
                                  }}
                                />
                                <span>Français</span>
                              </>
                            )}
                          </span>
                        </NavDropdown.Item>
                      );
                    })}
                  </NavDropdown>
                  <div className="pfpResponsiveHeader">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      {this.props.picture ? (
                        this.props.picture.images ? (
                          this.props.picture.images.user ? (
                            <img
                              className="profilePic"
                              src={this.props.picture.images.user.img}
                              alt={"profil"}
                              style={{
                                width: "25px",
                                height: "25px",
                              }}
                            />
                          ) : (
                            userImg
                          )
                        ) : (
                          userImg
                        )
                      ) : (
                        userImg
                      )}
                    </div>
                    <a href="/profile">
                      {this.props.user
                        ? this.props.user.user
                          ? this.props.user.user.firstName +
                            " " +
                            this.props.user.user.lastName
                          : null
                        : null}
                    </a>
                  </div>
                  <div className="disconectResponsiveHeader">
                    <img
                      src={`/img/logoutGreen.png`}
                      alt={"profil"}
                      style={{
                        margin: "0 7.5px",
                        alignSelf: "center",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    <a
                      onClick={(e) => {
                        // Do NOT end session here; logout action handles sync + end
                        this.context.close();
                        this.props.logout();
                        this.props.deleteProfilePictures(this.state.images);
                        this.setState({
                          isOpen: false,
                          navbarExpanded: false,
                        });
                      }}
                      href={"/logout"}
                      style={{ color: "#424141" }}
                    >
                      <Translation str={"HeaderLogout"} />
                    </a>
                  </div>
                  <div
                    className="pfpCentered"
                    style={{ cursor: "pointer", position: "relative" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        marginTop: "8px",
                      }}
                      onClick={(e) => {
                        this.setState({ profilePopupOpen: true });
                      }}
                    >
                      {this.props.picture ? (
                        this.props.picture.images ? (
                          this.props.picture.images.user ? (
                            <img
                              className="profilePic"
                              src={this.props.picture.images.user.img}
                              alt={"profil"}
                              style={{
                                width: "40px",
                                height: "40px",

                                border: this.context.connectionStatus
                                  ? this.context.connectionStatus ===
                                    "CONNECTED"
                                    ? "2px solid #008910"
                                    : null
                                  : null,
                              }}
                            />
                          ) : (
                            userImg
                          )
                        ) : (
                          userImg
                        )
                      ) : (
                        userImg
                      )}
                    </div>
                    {this.state.profilePopupOpen ? (
                      <OutsideAlerter
                        handleClickOutside={() => {
                          this.setState({ profilePopupOpen: false });
                        }}
                      >
                        <div
                          id="modifProfil"
                          //  style={{
                          //    display: this.state.profilePopupOpen
                          //      ? "block"
                          //      : "none",
                          //  }}
                        >
                          <div>
                            <img
                              src="/img/user.png"
                              style={{
                                width: "25px",
                                height: "25px",
                                margin: "0px 7.5px",
                                alignSelf: "center",
                              }}
                            />
                            {/* <a
                              onClick={(e) => {
                                this.setState({
                                  isOpen: false,
                                  navbarExpanded: false,
                                });
                              }}
                              href={"/profile"}
                              style={{ color: "#424141" }}
                            >
                              <Translation str={"HeaderParameter"} />
                            </a> */}
                            <ProfileLink
                              navLinkClicked={(e) => {
                                this.setState({
                                  isOpen: false,

                                  navbarExpanded: false,
                                });
                              }}
                              style={{ color: "#424141" }}
                              filter={
                                this.props.isAuthenticated ? "/profile" : "./"
                              }
                            >
                              <Translation str={"HeaderParameter"} />
                            </ProfileLink>
                          </div>
                          <div>
                            <img
                              src="/img/logout.png"
                              style={{
                                width: "25px",
                                height: "25px",
                                margin: "0 7.5px",
                                alignSelf: "center",
                              }}
                            />
                            <ProfileLink
                              navLinkClicked={(e) => {
                                console.log("navldkf");
                                // Do NOT end session here; logout action handles sync + end
                                this.context.close();
                                this.props.logout();
                                this.props.deleteProfilePictures(
                                  this.state.images
                                );
                                this.setState({
                                  isOpen: false,
                                  navbarExpanded: false,
                                });
                              }}
                              style={{ color: "#424141" }}
                              filter={"/logout"}
                            >
                              {/* <a
                              onClick={() => {
                                this.context.close();
                                this.props.logout();
                                this.props.deleteProfilePictures(
                                  this.state.images
                                );
                                this.setState({
                                  isOpen: false,
                                  navbarExpanded: false,
                                });
                              }}
                              href={"/logout"}
                              style={{ color: "#424141" }}
                            > */}
                              <Translation str={"HeaderLogout"} />
                              {/* </a> */}
                            </ProfileLink>
                          </div>
                        </div>
                      </OutsideAlerter>
                    ) : null}
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>{" "}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  page: state.page,
  isAuthenticated: state.auth.isAuthenticated,
  picture: state.picture,
  user: state.user,
  ws: state.ws,
  company: state.company,
  // this is props so add prop type
});

export default connect(mapStateToProps, {
  changePage,
  clearErrors,
  getProjects,
  logout,
  deleteProfilePictures,
  pictureDownload,
  updateUser,
  changeLanguage,
  removeGreetings,
})(HeaderLoggedIn);
